module.exports = __webpack_public_path__ + "static/img/banner-cursos-500x750.db2cf8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-cursos-500x750.jpg
// module id = WfBq
// module chunks = 47